module.exports = __webpack_public_path__ + "img/pay-fail.0e2e16b2.png";